import { html } from "lit";
var icon_calendar_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M22.125 2c.483 0 .875.392.875.875v4.25a.875.875 0 01-1.75 0v-4.25c0-.483.392-.875.875-.875zM9.775 2c.483 0 .875.392.875.875v4.25a.875.875 0 01-1.75 0v-4.25c0-.483.392-.875.875-.875zM5.432 3.891C3.547 3.891 2 5.46 2 7.37v20.154C2 29.433 3.547 31 5.432 31h21.136C28.453 31 30 29.433 30 27.523V7.369c0-1.91-1.547-3.478-3.432-3.478h-1.857c-.493-.007-.953.446-.953.946 0 .5.46.953.953.946h1.857c.881 0 1.565.693 1.565 1.586v5.348H3.867V7.37c0-.893.684-1.586 1.565-1.586h1.857c.493.007.943-.446.943-.946 0-.5-.45-.953-.943-.946H5.432zm6.835 0c-.516 0-.934.424-.934.946s.418.946.934.946h7.466c.516 0 .934-.424.934-.946s-.418-.946-.934-.946h-7.466zm-8.4 10.718h24.266v12.914c0 .893-.684 1.586-1.565 1.586H5.432c-.881 0-1.565-.693-1.565-1.586V14.609z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_calendar_default as default
};
//# sourceMappingURL=icon-calendar.js.map
